<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-2">
    <IFormField>
      <label iLabel>{{ t("keyword-segment-modal.segment_name") }}</label>
      <input
        iInput
        [placeholder]="t('keyword-segment-modal.name_input_tooltip')"
        [(ngModel)]="name"
        [maxLength]="80"
        type="text"
        class="w-full"
        data-testid="segment-name-input"
      />
    </IFormField>

    <app-asin-selection
      class="min-h-0 flex-1"
      [selectedAsins]="asinsList"
      [csvExport]="true"
      [allowOtherCatalog]="true"
      (selectedAsinsChange)="asinsList = $event"
    />

    <div class="flex justify-end gap-2">
      <button iButton variant="secondary" size="md" (click)="close()">{{ t("common.cancel") }}</button>
      <button
        iButton
        testId="btn-confirm-segment"
        class="w-2/4"
        type="submit"
        size="md"
        [iTooltip]="invalidTooltip()"
        [disabled]="isInvalid() || isReadOnly"
        (click)="saveSegment()"
      >
        {{ t("common.save") }}
      </button>
    </div>
  </div>
</ng-container>
